var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';
import WithValidation from '../../lib/WithValidation';
import require from '../../lib/WithValidation/rules/required';
import number from '../../lib/WithValidation/rules/number';
import AccordionWidget from '../AccordionWidget';
import AmountItemHeader from './AmountItemHeader';
import AmountItemContent from './AmountItemContent';
import PeriodItemHeader from './PeriodItemHeader';
import { FormattedRelativeTime } from 'react-intl';
import PeriodItemContent from './PeriodItemContent';
import marked from 'marked';
import translate from '../../lib/utils/translate';
import { selectUnit } from '@formatjs/intl-utils';

var ResponsibleGaming = function (_PureComponent) {
  _inherits(ResponsibleGaming, _PureComponent);

  function ResponsibleGaming(props) {
    _classCallCheck(this, ResponsibleGaming);

    var _this = _possibleConstructorReturn(this, (ResponsibleGaming.__proto__ || Object.getPrototypeOf(ResponsibleGaming)).call(this, props));

    _this._handleType = function (item, displayLimit) {
      var data = _this.props.data;


      _this.setState({
        expandedIndex: data.indexOf(item),
        type: item.action,
        amount: null,
        timespan: 1,
        limitId: null,
        confirmLimit: null,
        canceledLimit: null,
        activeLimit: null,
        multipleLimits: null,
        activeLimits: null,
        cooldownLimit: null,
        pendingLimit: null,
        transactionLimit: null,
        submitButton: false,
        maxAmount: null,
        increment: 1000
      });

      if (item.action === 'LoginTime') _this.setState({
        maxAmount: item.config[0].maxAmount
      });

      if (item.action === 'RealityCheck') {
        _this.setState({
          amount: displayLimit && displayLimit.Amount
        });
      }

      if (['Block', 'RealityCheck', 'LoginPeriodBlock', 'Session', 'SelfExclude', 'TimePeriod'].includes(item.action)) {
        _this.setState({
          timespan: parseInt(1),
          amount: item.config[0].value
        });
      }

      if (data.indexOf(item) === _this.state.expandedIndex) {
        _this.setState({
          expandedIndex: null
        });
      }

      if (displayLimit) {
        var _data = _this.props.data;

        var type = _data && _data.find(function (d) {
          return d.action === item.action;
        });
        var config = type && type.config.find(function (t) {
          return t.value === displayLimit.Timespan;
        });

        _this.setState({
          timespan: displayLimit.Timespan,
          maxAmount: config && config.maxAmount
        }, function () {
          return _this.handleTimespanAmounts(_this.state.timespan);
        });
      }
    };

    _this.handleLimitAmount = function (e) {
      if (_this.state.maxAmount) {
        if (e.currentTarget.value <= _this.state.maxAmount) {
          _this.setState({
            amount: parseInt(e.currentTarget.value) || '',
            submitButton: true
          });
        } else {
          _this.setState({
            amount: _this.state.maxAmount
          });
        }
      } else {
        _this.setState({
          submitButton: true,
          amount: parseInt(e.currentTarget.value) || ''
        });
      }

      if (e.currentTarget.value >= _this.state.activeLimit.Amount && _this.props.hasDepositLimitIncreaseBlock) {
        _this.setState({
          submitButton: false
        });
      }
    };

    _this.handlePeriodAmount = function (e) {
      if (e.currentTarget) {
        _this.setState({
          timespan: parseInt(1),
          amount: parseInt(e.currentTarget.value)
        });
      }
    };

    _this.deleteAmount = function () {
      _this.setState({
        amount: null,
        timespan: null
      });
    };

    _this.handleLimitTimespan = function (item) {
      _this.setState({
        timespan: item.value,
        maxAmount: item && item.maxAmount
      }, function () {
        return _this.handleTimespanAmounts(_this.state.timespan);
      });
    };

    _this.handleTimespanAmounts = function (timespan) {
      _this.setState({
        amount: null,
        confirmLimit: null,
        canceledLimit: null,
        pendingLimit: null,
        activeLimit: null,
        multipleLimits: null,
        cooldownLimit: null,
        transactionLimit: null,
        submitButton: false
      });

      var canceledLimit = _this.canceledLimits && _this.canceledLimits.find(function (l) {
        return l.Timespan === timespan;
      });

      if (canceledLimit) _this.setState({
        canceledLimit: canceledLimit,
        amount: canceledLimit.Amount,
        pendingLimit: null,
        activeLimit: null
      });

      var allActiveLimits = _this.activeLimits && _this.activeLimits.filter(function (l) {
        return l.Timespan === timespan;
      }).sort(function (a, b) {
        return a.Amount - b.Amount;
      });

      var activeLimit = allActiveLimits && allActiveLimits.find(function (l) {
        return l.Timespan === timespan;
      });

      var cooldownLimit = _this.cooldownLimits && _this.cooldownLimits.find(function (l) {
        return l.Timespan === timespan;
      });

      var transactionLimit = _this.transactionLimit;

      if (_this.state.type === 'RealityCheck' && _this.confirmLimits && _this.confirmLimits.length > 0) _this.setState({
        confirmLimit: _this.confirmLimits
      });

      var confirmLimit = _this.confirmLimits && _this.confirmLimits.find(function (l) {
        return l.Timespan === timespan;
      });

      if (allActiveLimits.length > 1) _this.setState({
        multipleLimits: allActiveLimits
      });

      if (confirmLimit) _this.setState({
        confirmLimit: confirmLimit
      });

      if (activeLimit && !canceledLimit) _this.setState({
        amount: activeLimit.Amount,
        activeLimit: activeLimit,
        pendingLimit: null
      });

      if (activeLimit && canceledLimit) _this.setState({
        amount: canceledLimit.Amount,
        activeLimit: canceledLimit,
        pendingLimit: activeLimit
      });

      if (transactionLimit) _this.setState({
        transactionLimit: transactionLimit
      });

      if (cooldownLimit) _this.setState({
        cooldownLimit: cooldownLimit
      });
    };

    _this.handleDecrement = function () {
      if (_this.state.type === 'ProductSession') {
        if (!_this.state.amount) return;

        return _this.setState({ amount: _this.state.amount - 1 });
      }

      if (_this.state.amount > 1) {
        _this.setState({
          amount: parseInt(_this.state.amount / 2),
          submitButton: true
        });
      }

      if (_this.state.activeLimit && _this.state.amount / 2 > _this.state.activeLimit.Amount) {
        _this.setState({
          amount: parseInt(_this.state.activeLimit.Amount),
          submitButton: false
        });
      }
    };

    _this.handleIncrement = function () {
      _this.setState({
        submitButton: true
      });

      if (_this.state.type === 'ProductSession') {
        if (!_this.state.amount) return _this.setState({ amount: 1 });

        return _this.setState({ amount: _this.state.amount + 1 });
      }

      if (!_this.state.amount && !_this.state.maxAmount) {
        _this.setState({
          amount: 1000
        });
      }

      if (!_this.state.maxAmount && _this.state.amount) {
        _this.setState({
          amount: parseInt(_this.state.amount * 2)
        });
      }

      if (_this.state.maxAmount && _this.state.amount && _this.state.amount <= _this.state.maxAmount) {
        _this.setState({
          amount: parseInt(_this.state.amount * 2)
        });
      }

      if (_this.state.maxAmount && !_this.state.amount) {
        _this.setState({
          amount: _this.state.maxAmount / 2
        });
      }

      if (_this.state.activeLimit && _this.state.amount * 2 >= _this.state.activeLimit.Amount && _this.props.hasDepositLimitIncreaseBlock) {
        _this.setState({
          amount: _this.state.activeLimit.Amount,
          submitButton: false
        });
      }
    };

    _this.handlePickLimit = function (item) {
      var handleCancel = _this.props.handleCancel;


      var limitsToDelete = _this.activeLimits && _this.activeLimits.filter(function (l) {
        return l.Timespan === _this.state.timespan && l.Id !== item;
      });

      limitsToDelete.map(function (limit) {
        handleCancel(limit.Id);
      });

      _this.setState({
        multipleLimits: null
      });
    };

    _this.state = {
      buttonLoading: null
    };
    return _this;
  }

  _createClass(ResponsibleGaming, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          data = _props.data,
          initialExpandedIndex = _props.initialExpandedIndex;

      if (data && initialExpandedIndex >= 0 && data[initialExpandedIndex]) {
        this._handleType(data[initialExpandedIndex]);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps, oldState) {
      var _this2 = this;

      var _props2 = this.props,
          limits = _props2.limits,
          limitsToConfirm = _props2.limitsToConfirm;

      var newProps = this.props;

      if (this.state.maxAmount && this.state.amount > this.state.maxAmount) {
        this.setState({
          amount: parseInt(this.state.maxAmount)
        });
      }

      if (oldProps.limits !== newProps.limits || this.state.type !== oldState.type) {
        var activeLimits = limits && limits.filter(function (l) {
          return l.Type === _this2.state.type && l.Status === 'Active';
        });
        var canceledLimits = limits && limits.filter(function (l) {
          return l.Type === _this2.state.type && l.Status === 'Canceled';
        });
        var confirmLimits = limitsToConfirm && limitsToConfirm.filter(function (l) {
          return l.Type === _this2.state.type;
        });
        var cooldownLimits = limits && limits.filter(function (l) {
          return l.Type === _this2.state.type && l.Status === 'Cooldown';
        });

        var reviewLimits = limits && limits.filter(function (l) {
          return l.Status === 'Review';
        });

        var reviewLimit = reviewLimits && reviewLimits[0];

        var activeLimit = activeLimits && activeLimits.find(function (l) {
          return l.Timespan === _this2.state.timespan;
        });
        var canceledLimit = canceledLimits && canceledLimits.find(function (l) {
          return l.Timespan === _this2.state.timespan;
        });
        var transactionLimit = limits && limits.find(function (l) {
          return l.Timespan === 0 && l.Type === _this2.state.type && l.Status === 'Active';
        });
        var cooldownLimit = cooldownLimits && cooldownLimits.find(function (l) {
          return l.Timespan === _this2.state.timespan;
        });

        var confirmLimit = confirmLimits && confirmLimits.find(function (l) {
          return l.Timespan === _this2.state.timespan;
        });

        if (canceledLimit) this.setState({
          canceledLimit: canceledLimit,
          amount: canceledLimit.Amount,
          pendingLimit: null,
          activeLimit: null
        });

        if (activeLimit && !canceledLimit) this.setState({
          amount: activeLimit.Amount,
          activeLimit: activeLimit,
          pendingLimit: null
        });

        this.setState({ reviewLimit: reviewLimit });

        if (activeLimit && canceledLimit) this.setState({
          amount: canceledLimit.Amount,
          activeLimit: canceledLimit,
          pendingLimit: activeLimit
        });

        if (transactionLimit) {
          this.setState({
            transactionLimit: transactionLimit
          });
        } else {
          this.setState({
            transactionLimit: null
          });
        }

        if (confirmLimit) {
          this.setState({
            confirmLimit: confirmLimit
          });
        } else {
          this.setState({
            confirmLimit: null
          });
        }

        if (cooldownLimit) {
          this.setState({
            cooldownLimit: cooldownLimit
          });
        } else {
          this.setState({
            cooldownLimit: null
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          data = _props3.data,
          intl = _props3.intl,
          errors = _props3.errors,
          onSubmit = _props3.onSubmit,
          limits = _props3.limits,
          currency = _props3.currency,
          handleConfirm = _props3.handleConfirm,
          handleDecline = _props3.handleDecline,
          handleCancel = _props3.handleCancel,
          onCancel = _props3.onCancel,
          jurisdiction = _props3.jurisdiction,
          limitsToConfirm = _props3.limitsToConfirm,
          isLoading = _props3.isLoading,
          hasDepositLimitIncreaseBlock = _props3.hasDepositLimitIncreaseBlock;


      var defaultItem = data.find(function (d) {
        return d.action === _this3.state.type;
      }) || {};

      var _state = this.state,
          canceledLimit = _state.canceledLimit,
          cooldownLimit = _state.cooldownLimit,
          pendingLimit = _state.pendingLimit;


      var timeUntilNewLimit = void 0;
      var timeUntilConfirm = void 0;
      var timeUntilDelete = void 0;

      timeUntilNewLimit = new Date(pendingLimit && pendingLimit.Activates + '+00:00' || canceledLimit && canceledLimit.Expires + '+00:00');

      timeUntilConfirm = cooldownLimit && new Date(cooldownLimit.Expires + '+00:00');

      timeUntilDelete = canceledLimit && new Date(canceledLimit.Canceled + '+00:00');

      timeUntilNewLimit = React.createElement(FormattedRelativeTime, selectUnit(timeUntilNewLimit));
      timeUntilConfirm = React.createElement(FormattedRelativeTime, selectUnit(timeUntilConfirm));
      timeUntilDelete = React.createElement(FormattedRelativeTime, selectUnit(timeUntilDelete));

      this.transactionLimit = limits && limits.find(function (l) {
        return l.Timespan === 0 && l.Type === _this3.state.type && l.Status === 'Active';
      });

      this.confirmLimits = limitsToConfirm && limitsToConfirm.filter(function (l) {
        return l.Type === _this3.state.type;
      });

      this.canceledLimits = limits && limits.filter(function (l) {
        return l.Type === _this3.state.type && l.Status === 'Canceled';
      });

      this.activeLimits = limits && limits.filter(function (l) {
        return l.Type === _this3.state.type && l.Status === 'Active';
      });

      this.cooldownLimits = limits && limits.filter(function (l) {
        return l.Type === _this3.state.type && l.Status === 'Cooldown';
      });

      var items = data.map(function (item, i) {
        var displayLimit = void 0;

        var displayLimits = limits && limits.filter(function (d) {
          return d.Type === item.action && (d.Status === 'Active' && !d.Activates || d.Status === 'Canceled' || d.Status === 'Cooldown');
        });

        if (displayLimits) {
          displayLimits.sort(function (a, b) {
            return a.RemainingAmount - b.RemainingAmount;
          });

          displayLimit = displayLimits[0];
        }

        if (['Deposit', 'NetLoss', 'Wager', 'LoginTime', 'ProductSession'].includes(item.action)) {
          return {
            item: item,
            displayLimit: displayLimit,
            header: React.createElement(AmountItemHeader, {
              content: item.content,
              title: translate({ id: 'label.type.' + item.action }, intl),
              currency: currency,
              displayLimit: displayLimit,
              type: item.action
            }),
            tooltip: item.content && marked(item.content),
            content: React.createElement(
              'div',
              { className: 'responsiblegaming-limit-item-content' },
              _this3.state.type === 'Deposit' && _this3.props.depositMessages && _this3.props.depositMessages(),
              React.createElement(AmountItemContent, {
                type: _this3.state.type,
                activeLimit: _this3.state.activeLimit,
                multipleLimits: _this3.state.multipleLimits,
                pendingLimit: _this3.state.pendingLimit,
                reviewLimit: _this3.state.reviewLimit,
                canceledLimit: _this3.state.canceledLimit,
                transactionLimit: _this3.state.transactionLimit,
                cooldownLimit: _this3.state.cooldownLimit,
                timeUntilNewLimit: timeUntilNewLimit,
                timeUntilConfirm: timeUntilConfirm,
                timeUntilDelete: timeUntilDelete,
                currency: currency,
                limits: limits,
                amount: _this3.state.amount,
                confirmLimit: _this3.state.confirmLimit,
                handleConfirm: handleConfirm,
                handleDecline: handleDecline,
                handleCancel: handleCancel,
                handlePickLimit: _this3.handlePickLimit,
                deleteAmount: _this3.deleteAmount,
                handleDecrement: _this3.handleDecrement,
                handleIncrement: _this3.handleIncrement,
                handleLimitAmount: _this3.handleLimitAmount,
                handleLimitTimespan: _this3.handleLimitTimespan,
                timespan: _this3.state.timespan,
                title: 'label.type.' + item.action,
                config: item.config,
                submitButton: _this3.state.submitButton,
                onCancel: onCancel,
                jurisdiction: jurisdiction,
                isLoading: isLoading,
                hasDepositLimitIncreaseBlock: hasDepositLimitIncreaseBlock
              })
            ),
            key: item.action + i
          };
        }

        if (['Block', 'RealityCheck', 'LoginPeriodBlock', 'Session', 'SelfExclude', 'TimePeriod'].includes(item.action)) {
          return {
            item: item,
            displayLimit: displayLimit,
            tooltip: item.content && marked(item.content),
            tooltipOpen: item.action === 'Block',
            header: React.createElement(PeriodItemHeader, {
              item: item,
              title: translate({ id: 'label.type.' + item.action }, intl),
              displayLimit: displayLimit || null
            }),
            content: React.createElement(
              'div',
              { className: 'responsiblegaming-limit-item-content' },
              React.createElement(PeriodItemContent, _extends({
                title: 'label.type.' + item.action,
                config: item.config,
                activeLimit: _this3.state.activeLimit,
                confirmLimit: _this3.state.confirmLimit,
                pendingLimit: _this3.state.pendingLimit,
                timespan: _this3.state.timespan,
                handleConfirm: handleConfirm,
                handleDecline: handleDecline,
                handleCancel: handleCancel,
                cooldownLimit: _this3.state.cooldownLimit,
                canceledLimit: _this3.state.canceledLimit,
                timeUntilNewLimit: timeUntilNewLimit,
                timeUntilConfirm: timeUntilConfirm,
                timeUntilDelete: timeUntilDelete,
                displayLimit: displayLimit,
                type: _this3.state.type,
                errors: errors,
                handlePeriodAmount: _this3.handlePeriodAmount,
                isLoading: isLoading,
                currency: currency
              }, defaultItem))
            ),
            key: item.action + i
          };
        } else {
          return {
            header: React.createElement(PeriodItemHeader, {
              title: translate({ id: 'label.type.' + item.action }, intl)
            }),
            key: item.action + i
          };
        }
      });

      return React.createElement(
        'div',
        { className: 'responsiblegaming-limit-selector' },
        React.createElement(
          'form',
          { onSubmit: onSubmit },
          React.createElement(AccordionWidget, {
            items: items,
            onClickHeader: function onClickHeader(e, key, item) {
              return _this3._handleType(item.item, item.displayLimit);
            }
          })
        )
      );
    }
  }]);

  return ResponsibleGaming;
}(PureComponent);

var rules = {
  Type: [[require, 'error.empty.type']],
  Timespan: [[require, 'error.empty.timespan']],
  Amount: [[require, number, 'error.number.amount']]
};

export default compose(WithValidation(rules), injectIntl)(ResponsibleGaming);